// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetTypeCodeApprvService = {};

AssetTypeCodeApprvService.getAssetTypeCodeApprvList = function (userInput) {
  return lossClient({
    url: "/AssetType/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetTypeCodeApprvService;
